"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = void 0;

var Queue =
/** @class */
function () {
  function Queue() {}

  Queue.prototype.QueueCommandMessageLevelType = function () {
    return [{
      slug: 'error',
      name: 'Error',
      description: null,
      isError: true,
      isWarning: false,
      isInfo: false
    }, {
      slug: 'warning',
      name: 'Warning',
      description: null,
      isError: false,
      isWarning: true,
      isInfo: false
    }, {
      slug: 'info',
      name: 'Info',
      description: null,
      isError: false,
      isWarning: false,
      isInfo: true
    }];
  };

  Queue.prototype.QueueTaskMessageLevelType = function () {
    return [{
      slug: 'error',
      name: 'Error',
      description: null,
      isError: true,
      isWarning: false,
      isInfo: false
    }, {
      slug: 'warning',
      name: 'Warning',
      description: null,
      isError: false,
      isWarning: true,
      isInfo: false
    }, {
      slug: 'info',
      name: 'Info',
      description: null,
      isError: false,
      isWarning: false,
      isInfo: true
    }];
  };

  return Queue;
}();

exports.Queue = Queue;